import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${p => p.theme.color.backgroundRush};
  display: flex;
  flex-direction: column ;
  border-radius: 40px ;
  padding: 20px;  ;
  box-sizing:border-box ;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content:center ;
  gap: 10px ;
`;

const FieldWrap = styled.div`
display: flex;
flex-direction: column ;
margin: 25px 110px 20px 0 ;
`;

const Button = styled.div`
`;

export const Styled = {
  Container,
  ContentContainer,
  FieldWrap,
  Button,
};
